import { useFormField } from "@/components/elements/FormField";
import { button, text } from "@/theme/colors";
import { Checkbox as MuiCheckbox, CheckboxProps, styled, Stack, FormControlLabel, Typography, Box } from "@mui/material";
import React, { FC, ReactNode } from "react";

export type TCheckboxProps = {
  label?: string;
  subLabel?: string;
  nonControl?: boolean;
  prefixLabel?: ReactNode;
} & CheckboxProps;

export const Checkbox: FC<TCheckboxProps> = ({ label, subLabel, nonControl = false, prefixLabel, ...rest }) => {
  const { field } = useFormField(nonControl);

  return (
    <CheckboxWrap>
      <FormControlLabel
        label={
          <Stack flexDirection="row" gap={0.5}>
            {prefixLabel}
            <Stack gap={0.5}>
              {label && (
                <Typography variant="body14" color={text.primary}>
                  {label}
                </Typography>
              )}
              {subLabel && (
                <Typography variant="cap12" color={text.secondary}>
                  {subLabel}
                </Typography>
              )}
            </Stack>
          </Stack>
        }
        control={<StyledCheckbox {...rest} {...field} />}
      />
    </CheckboxWrap>
  );
};

const CheckboxWrap = styled(Box)`
  .MuiFormControlLabel-root {
    align-items: flex-start;
    gap: 12px;
    margin: 0;
  }
`;

const StyledCheckbox = styled(MuiCheckbox)`
  width: 18px;
  height: 18px;
  color: ${button.primary}!important;
  &.Mui-disabled {
    color: ${button.disable}!important;
  }
`;
